/**
 * Extrae el mensaje que devolvió la API, con un texto de respaldo si no vino ninguno.
 *
 * El backend responde `{ statusCode, message, ... }`, y ese `message` suele ser lo único que
 * explica qué pasó — por ejemplo "Error en el procedimiento almacenado SP_Cotizacion_After:
 * Divide by zero error encountered." o "El desarrollo debe ser mayor a 0". Descartarlo y
 * mostrar un texto fijo deja al usuario sin nada accionable y obliga a mirar los logs del
 * servidor para saber qué falló.
 *
 * @param {unknown} err Error de axios, o cualquier cosa que haya llegado al catch.
 * @param {string} respaldo Mensaje a usar cuando la API no devolvió ninguno.
 * @returns {string}
 */
export function mensajeErrorApi(err, respaldo = 'Hubo un error') {
  const mensajeApi = err?.response?.data?.message;

  // Nest puede devolver `message` como arreglo cuando falla la validación del DTO.
  if (Array.isArray(mensajeApi)) {
    return mensajeApi.filter(Boolean).join(' · ') || respaldo;
  }
  if (typeof mensajeApi === 'string' && mensajeApi.trim()) {
    return mensajeApi;
  }

  // Sin respuesta del servidor (timeout, red caída) queda el mensaje de axios.
  if (typeof err?.message === 'string' && err.message.trim()) {
    return err.message;
  }

  return respaldo;
}
